// Story 7.1 — auth card composing sign-in + create-account tabs.
//
// Rendered inside <LandingPage>. Two tabs: "Sign in" (default) and
// "Create account". Tab labels are literal — no marketing decoration.
// Card visual: bg-brand-forest-800 lift with antique-gold hairline
// border on max-w-md container.

import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@greenhold/components";

import { SignInForm } from "./SignInForm";
import { CreateAccountForm } from "./CreateAccountForm";

type TabValue = "sign-in" | "create-account";

export function AuthCard() {
  const [tab, setTab] = useState<TabValue>("sign-in");

  return (
    <div
      className="w-full rounded border border-brand-gold-500/40 bg-brand-forest-800 p-6"
      data-testid="auth-card"
    >
      <Tabs
        value={tab}
        onValueChange={(v) => setTab(v as TabValue)}
        className="flex flex-col gap-4"
      >
        <TabsList className="grid grid-cols-2 border-b border-brand-gold-500/30 text-brand-paper-100">
          <TabsTrigger
            value="sign-in"
            className="data-[state=active]:border-brand-gold-300 data-[state=active]:text-brand-gold-300"
            data-testid="tab-sign-in"
          >
            Sign in
          </TabsTrigger>
          <TabsTrigger
            value="create-account"
            className="data-[state=active]:border-brand-gold-300 data-[state=active]:text-brand-gold-300"
            data-testid="tab-create-account"
          >
            Create account
          </TabsTrigger>
        </TabsList>
        <TabsContent value="sign-in">
          <SignInForm />
        </TabsContent>
        <TabsContent value="create-account">
          <CreateAccountForm onSwitchToSignIn={() => setTab("sign-in")} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
